<div *ngIf="mediaUrl">
  <div class="modal-content border-0 p-1">
    <div class="modal-header border-0 p-1">
      <button type="button" class="btn-close" aria-label="Close" (click)="modelRef.dismiss('Cross click')"></button>
    </div>
    <div *ngIf="isImage()">
      <img src="{{mediaUrl}}" width="100%" />
    </div>
    <div *ngIf="isVideo()">
      <div class="modal-body" *ngIf="youtubestatus ==='Youtube'" [innerHtml]="getVideoElement()">
      </div>
      <div class="modal-body" *ngIf="youtubestatus ==='Video'">
        <video id="video1" width="100%" height="400" controls>
          <source src="{{mediaUrl}}" type="video/mp4">
        </video>
      </div>
    </div>
    <div *ngIf="isAudio()">
      <div class="modal-body text-center">
        <audio id="video1" width="100%" controls>
          <source src="{{mediaUrl}}" type="video/mp4">
        </audio>
      </div>
    </div>
  </div>
</div>